import { render, staticRenderFns } from "./VehicleDetail.vue?vue&type=template&id=7dbcb630&scoped=true"
import script from "./VehicleDetail.vue?vue&type=script&lang=js"
export * from "./VehicleDetail.vue?vue&type=script&lang=js"
import style0 from "./VehicleDetail.vue?vue&type=style&index=0&id=7dbcb630&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbcb630",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dbcb630')) {
      api.createRecord('7dbcb630', component.options)
    } else {
      api.reload('7dbcb630', component.options)
    }
    module.hot.accept("./VehicleDetail.vue?vue&type=template&id=7dbcb630&scoped=true", function () {
      api.rerender('7dbcb630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vehicle/VehicleDetail.vue"
export default component.exports